import type { IExpenseTransportation } from './ExpenseTransportation.interface';
import { PaymentFrequency } from '../global/PaymentFrequency.enum';

export default class ExpenseTransportation implements IExpenseTransportation {
  motorVehicleInsurance: number;
  motorVehicleInsuranceFrequency: PaymentFrequency;
  motorVehicleInsuranceComments: string;
  motorVehicleRegistration: number;
  motorVehicleRegistrationFrequency: PaymentFrequency;
  motorVehicleRegistrationComments: string;
  fuelTollsParking: number;
  fuelTollsParkingFrequency: PaymentFrequency;
  fuelTollsParkingComments: string;
  repairsServicingTyres: number;
  repairsServicingTyresFrequency: PaymentFrequency;
  repairsServicingTyresComments: string;
  busTrainTramFerry: number;
  busTrainTramFerryFrequency: PaymentFrequency;
  busTrainTramFerryComments: string;
  carShareUberTaxi: number;
  carShareUberTaxiFrequency: PaymentFrequency;
  carShareUberTaxiComments: string;

  static build = (data: IExpenseTransportation) => new ExpenseTransportation(data);
  static blank = () => new ExpenseTransportation();

  /**
   * Constructor
   * @param {IExpenseTransportation} data
   */
  constructor(data?: IExpenseTransportation) {
    this.motorVehicleInsurance = parseFloat(data?.motorVehicleInsurance || 0);
    // TODO: data?.motorVehicleInsuranceFrequency is legacy data structure
    this.motorVehicleInsuranceFrequency = data?.motorVehicleInsuranceFrequency
      ? PaymentFrequency.of(
          data?.motorVehicleInsuranceFrequency?.name ||
            data?.motorVehicleInsuranceFrequency.toString()
        )
      : PaymentFrequency.annually;
    this.motorVehicleInsuranceComments = data?.motorVehicleInsuranceComments || '';
    this.motorVehicleRegistration = parseFloat(data?.motorVehicleRegistration || 0);
    // TODO: data?.motorVehicleRegistrationFrequency is legacy data structure
    this.motorVehicleRegistrationFrequency = data?.motorVehicleRegistrationFrequency
      ? PaymentFrequency.of(
          data?.motorVehicleRegistrationFrequency?.name ||
            data?.motorVehicleRegistrationFrequency.toString()
        )
      : PaymentFrequency.annually;
    this.motorVehicleRegistrationComments = data?.motorVehicleRegistrationComments || '';
    this.fuelTollsParking = parseFloat(data?.fuelTollsParking || 0);
    // TODO: data?.fuelTollsParkingFrequency is legacy data structure
    this.fuelTollsParkingFrequency = data?.fuelTollsParkingFrequency
      ? PaymentFrequency.of(
          data?.fuelTollsParkingFrequency?.name || data?.fuelTollsParkingFrequency.toString()
        )
      : PaymentFrequency.monthly;
    this.fuelTollsParkingComments = data?.fuelTollsParkingComments || '';
    this.repairsServicingTyres = parseFloat(data?.repairsServicingTyres || 0);
    // TODO: data?.repairsServicingTyresFrequency is legacy data structure
    this.repairsServicingTyresFrequency = data?.repairsServicingTyresFrequency
      ? PaymentFrequency.of(
          data?.repairsServicingTyresFrequency?.name ||
            data?.repairsServicingTyresFrequency.toString()
        )
      : PaymentFrequency.annually;
    this.repairsServicingTyresComments = data?.repairsServicingTyresComments || '';
    this.busTrainTramFerry = parseFloat(data?.busTrainTramFerry || 0);
    // TODO: data?.busTrainTramFerryFrequency is legacy data structure
    this.busTrainTramFerryFrequency = data?.busTrainTramFerryFrequency
      ? PaymentFrequency.of(
          data?.busTrainTramFerryFrequency?.name || data?.busTrainTramFerryFrequency.toString()
        )
      : PaymentFrequency.monthly;
    this.busTrainTramFerryComments = data?.busTrainTramFerryComments || '';
    this.carShareUberTaxi = parseFloat(data?.carShareUberTaxi || 0);
    // TODO: data?.carShareUberTaxiFrequency is legacy data structure
    this.carShareUberTaxiFrequency = data?.carShareUberTaxiFrequency
      ? PaymentFrequency.of(
          data?.carShareUberTaxiFrequency?.name || data?.carShareUberTaxiFrequency.toString()
        )
      : PaymentFrequency.monthly;
    this.carShareUberTaxiComments = data?.carShareUberTaxiComments || '';
  }
}
